
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'

import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import { Card } from 'primereact/card'

import back from '../assets/images/back.svg'
import drawChart from '../_charts/d3charts'
import { numberWithCommas } from '../_common/utils'

function PreviewComponent({ chartData, getCompanyBySectorIndustyChartData, linkChartData,
  selectedChartNode, industryChartData, selectedCompanyNode, linkCompanyData, selectedCompany }) {
  const [isDialogVisible, setIsDialogVisible] = useState(false)
  useEffect(() => {
    if (chartData) {
      changeChart('chart', chartData, true)
    }
    if (industryChartData) {
      changeChart('industryChart', industryChartData, false)
    }

  }, [chartData, selectedChartNode, industryChartData, selectedCompanyNode, selectedCompany])

  const changeChart = (divChartId, data, isZoomNeeded) => {
    const chartDiv = document.getElementById(divChartId)
    if (chartDiv) {
      const childNodes = chartDiv.querySelectorAll('*')
      if (childNodes.length <= 0 || chartDiv === 'industryChart')
        drawChart('#' + divChartId, window.innerHeight, window.innerWidth, data, linkChartData, isZoomNeeded, linkCompanyData)
    }

  }
  const history = useHistory()
  const showViewMoreChart = () => {
    if (null != selectedChartNode && null != selectedChartNode.parent) {
      getCompanyBySectorIndustyChartData(selectedChartNode.data.sectorId, selectedChartNode.data.industryId)
      setIsDialogVisible(true)
    }
  }
  const showViewMore = () => {
    if (null != selectedChartNode && null != selectedChartNode.parent) {
      return <div className="title flexCenter"><div id="sector-detail">{selectedChartNode.parent.data.name} - {selectedChartNode.data.name}</div><Button onClick={showViewMoreChart} label="View More" className="p-button-raised p-button-rounded inputHolder--formBtn m-l-10"></Button></div>

    }
  }
  const BackClick = () => {
    history.goBack()
  }
  const viewCompany = (id) => {
    history.push('/dashboard/view-company/' + id)
  }
  return (
    <div className="App">
      <Card className="cardBase addSector previewSection">
        <div className="titleCon m-b-20">
          <p className="title flex">
            <img src={back} alt={back} className="m-r-10 pointer" onClick={() => BackClick()} />COMPANIES VS MARKET CAPITALIZATION
          </p>
          {showViewMore()}
        </div>
        <div id="chart" className="chartCon">
        </div>
        <Dialog header={null != selectedChartNode && null != selectedChartNode.parent ? selectedChartNode.parent.data.name + ' - ' + selectedChartNode.data.name : 'Company'} className="industryChartCon" visible={isDialogVisible} style={{ width: '100vw' }} modal={true} onHide={() => setIsDialogVisible(false)}>
          <div>
            {selectedCompanyNode && selectedCompany ? <div className="mapContent">
              <div className="viewLogo">
                {selectedCompany && selectedCompany.logoURL && selectedCompany.logoPath ? <img alt="Company Logo" src={`${selectedCompany.logoPath}`} style={{ width: '100%' }}></img> : ''}
                {(selectedCompany && selectedCompany.encodedImageString) && <img alt="Company Logo" src={`data:image/jpeg;base64,${selectedCompany.encodedImageString}`} style={{ width: '80px' }}></img>}
              </div>
              <div className="mapContentSec">
                <div> <span className="mapHeading">Company Name:</span>{selectedCompanyNode.data ? selectedCompanyNode.data.name : ''}</div>
                <div><span className="mapHeading">Ticker:</span> {selectedCompany.ticker}</div>
                <div><span className="mapHeading">Market Capitalization:</span>${numberWithCommas(selectedCompany.marketCapitalization)}</div>
                <div><span className="mapHeading">Sector:</span>{selectedCompany?.sector ? selectedCompany.sector.name : '--'}</div>
                <div><span className="mapHeading">Industry:</span>{selectedCompany?.industry ? selectedCompany.industry.name : '--'}</div>
                <div><span className="mapHeading">Exchange:</span>{selectedCompany?.exchange ? selectedCompany.exchange.name : '--'}</div>
              </div>
              <Button label="View More" className="p-button-raised p-button-rounded inputHolder--formBtn" onClick={() => viewCompany(selectedCompany.companyId)} />
            </div> : ''}
            <div id="industryChart"></div>
          </div>
        </Dialog>
      </Card>
    </div>
  )
}
PreviewComponent.propTypes = {
  chartData: PropTypes.object,
  getSectorChartData: PropTypes.func,
  getCompanyBySectorIndustyChartData: PropTypes.func,
  linkChartData: PropTypes.func,
  selectedChartNode: PropTypes.object,
  industryChartData: PropTypes.object,
  selectedCompanyNode: PropTypes.object,
  linkCompanyData: PropTypes.func,
  selectedCompany: PropTypes.object
}
export default PreviewComponent
